export const SERVER_URL = "http://threeback.hellomh.site";

export const API_SEVER_URL = "";
